import { render } from "./acceptance-form.vue?vue&type=template&id=50294027&scoped=true"
import script from "./acceptance-form.vue?vue&type=script&lang=js"
export * from "./acceptance-form.vue?vue&type=script&lang=js"

import "./acceptance-form.vue?vue&type=style&index=0&id=50294027&scoped=true&lang=scss"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50294027"]])

export default __exports__